import { render, staticRenderFns } from "./UserProfileDropdown.vue?vue&type=template&id=24083b6f&"
import script from "./UserProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./UserProfileDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports